// src
import packageJSON from "../../package.json";
import {
  fetchCourses,
  fetchGroups,
  fetchPeople,
  fetchRooms,
  coursesSuccess,
  groupsSuccess,
  peopleSuccess,
  roomsSuccess,
} from "../actions/resources";

// general
export const APP_VERSION = packageJSON.version;

// local storage version, changing this will unlog people
export const STORAGE_VERSION = "v1-3"; // increment only, don't put a "."

// format of prefs saved to the server, versioning helps migrating
export const PREFS_VERSION = 1;

// time
export const MINUTE = 60 * 1000;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;

// presets
export const MY_PLANNING_ID = "mine";
export const PresetType = {
  CATEGORY: -1, // User defined category (in my favorites)
  RESOURCE: 1, // identified by a resource type (course, group...) and an id
  PERMANENT: 2, // uuid and definition (params) containing possibly several resources
  INSTANT: 3, // no uuid: defined by list of params sent in URL
};
export const PresetSection = {
  LOCAL: 1,
  FAVORITE: 2,
  POPULAR: 3,
};
export const ResourceType = {
  UNKNOWN: 0,
  PERSON: 1,
  ROOM: 2,
  GROUP: 3,
  COURSE: 4,
};
export const FAV_CATEGORY_PREFIX = ">favCat";

export const FETCHABLE_RESOURCES = [
  {
    type: ResourceType.COURSE,
    singular: "course",
    plural: "courses",
    idsLabel: "courseIds",
    fetch: fetchCourses,
    success: coursesSuccess,
  },
  {
    type: ResourceType.ROOM,
    singular: "room",
    plural: "rooms",
    idsLabel: "roomIds",
    fetch: fetchRooms,
    success: roomsSuccess,
  },
  {
    type: ResourceType.PERSON,
    singular: "person",
    plural: "people",
    idsLabel: "peopleIds",
    fetch: fetchPeople,
    success: peopleSuccess,
  },
  {
    type: ResourceType.GROUP,
    singular: "group",
    plural: "groups",
    idsLabel: "groupIds",
    fetch: fetchGroups,
    success: groupsSuccess,
  },
];

// UX
export const MAX_LARGE_WIDTH = 901;
export const MAX_SMALL_WIDTH = 600;
export const MAX_X_SMALL_WIDTH = 460;
